var map = {
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";